import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
export function ProductOverview() {
  const items = [{
    icon: '📘',
    title: 'PRODUCTO PRINCIPAL: CÓDIGO ALIMENTARIO',
    desc: 'El Sistema Maestro de Estrategias y Protocolos de Intervención. El manual clínico que ninguna formación universitaria te dio. Desde la tolerancia visual hasta la masticación coordinada, con protocolos exactos para cada nivel.',
    bullets: ['Fundamentos neurofisiológicos de la alimentación', 'Jerarquía de los 10 Niveles de Intervención', '100+ Protocolos de Actividades con ficha técnica completa', 'Protocolos de Transición, Expansión y Exposición Sensorial', 'Actividades de Habilidades Oromotoras paso a paso', 'Adaptaciones para TEA, ARFID y Selectividad Sensorial', 'Hojas de Registro Clínico para medir avances reales', 'Criterios para saber cuándo subir de nivel y cuándo sostener'],
    featured: true
  }, {
    icon: '🎁',
    title: 'BONO #1: NEURO-PANTALLAS',
    desc: 'El impacto de la dopamina digital en la alimentación infantil. Por qué la pantalla en la mesa destruye el trabajo terapéutico y cómo resolverlo con un protocolo claro.',
    bullets: ['Impacto neurológico de las pantallas en la interocepción', 'Cómo afecta específicamente a niños con TEA al comer', 'Protocolo de Higiene Dopaminérgica paso a paso', 'Estrategia de retirada progresiva sin crisis conductual', '3 casos clínicos resueltos con ejemplos reales', 'Recomendaciones prácticas para entregar a las familias']
  }, {
    icon: '🎁',
    title: 'BONO #2: RADAR ARFID PRO',
    desc: 'Guía de Screening y Diagnóstico Diferencial. La herramienta de precisión clínica para saber exactamente con qué tipo de caso estás trabajando.',
    bullets: ['Diferenciación técnica entre Picky Eating, Neofobia y ARFID', 'Tabla comparativa de perfiles con criterios clínicos claros', 'Checklist de 15 Red Flags para derivación inmediata', 'Criterios DSM-5 explicados para uso clínico práctico', 'Manejo de la ansiedad extrema por evitación en sesión', 'Pautas para comunicar el diagnóstico diferencial a la familia']
  }, {
    icon: '🎁',
    title: "BONO #3: FLASH PLANNER 5'",
    desc: 'El sistema táctico de organización para terapeutas. Deja de perder horas planificando. Organizá toda tu semana clínica en minutos.',
    bullets: ['Arquitectura exacta de una sesión de 45 minutos', 'Plantilla de planificación rápida con checkmarks', 'Formato de registro de evolución en menos de 5 minutos', 'Sistema de objetivos semanales por paciente', 'Modelo de devolución rápida a la familia al cierre de sesión', 'Estrategias para reducir el agotamiento mental profesional']
  }, {
    icon: '🎁',
    title: 'BONO #4: PARENT COACH PACK',
    desc: 'Herramientas de Liderazgo y Comunicación Familiar. El kit completo para que los padres dejen de ser un obstáculo y se conviertan en tu mejor equipo de apoyo.',
    bullets: ['Guiones de autoridad para explicar por qué jugar es intervenir', 'Infografía de Reglas de Oro del Comedor Responsivo', 'Cómo manejar la frustración y la culpa parental', 'Preguntas clave para la entrevista inicial con la familia', 'Cheat Sheets para entregar a los padres en consulta', 'Respuestas exactas para las objeciones más frecuentes']
  }, {
    icon: '🎁',
    title: 'BONO #5: MATRIZ DE EXPANSIÓN 360°',
    desc: 'Ingeniería de Puentes Alimentarios. El mapa técnico para saber exactamente qué alimento presentar después, sin adivinar y sin retrocesos.',
    bullets: ['Propiedades organolépticas de los alimentos para la intervención', 'Tablas de equivalencias sensoriales por textura, color y sabor', 'Técnica del Cambio Mínimo para evitar el rechazo neofóbico', 'Food Chaining evolucionado con ejemplos clínicos reales', 'Mapa de progresión de texturas de líquido a sólido complejo', 'Plantilla personalizable para construir rutas de expansión propias']
  }];
  const features = ['Fichas técnicas listas para aplicar en sesión', 'Lenguaje clínico claro, sin relleno teórico', 'Basado en integración sensorial y enfoque responsivo', 'Hojas de registro imprimibles para medir avances', 'Adaptaciones para TEA, ARFID y selectividad sensorial', 'Criterios de progresión medibles y accionables'];
  return <section className="bg-cream py-16 px-4" data-id="element-193">
      <div className="max-w-6xl mx-auto" data-id="element-194">
        <div className="text-center mb-12" data-id="element-195">
          <h2 className="text-3xl md:text-5xl font-bold text-ink mb-4 font-serif" data-id="element-196">
            🏆 CÓDIGO ALIMENTARIO™
          </h2>
          <p className="text-lg md:text-2xl text-primary font-bold mb-2 tracking-wide" data-id="element-197">
            Producto Principal + 5 Bonos — 80/100+ páginas
          </p>
          <p className="text-base md:text-xl text-muted font-medium" data-id="element-198">
            El sistema completo de estrategias y protocolos de intervención para
            terapeutas de alimentación infantil.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-199">
          {items.map((item, idx) => <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.05
        }} key={idx} className={`bg-white rounded-2xl p-8 border ${item.featured ? 'border-gold shadow-md md:col-span-2' : 'border-border shadow-sm'} hover:shadow-md transition-shadow`} data-id="element-200">
              <div className="flex items-start mb-4" data-id="element-201">
                <span className="text-4xl mr-4" data-id="element-202">{item.icon}</span>
                <div data-id="element-203">
                  <h4 className="text-xl font-bold text-ink font-serif leading-tight" data-id="element-204">
                    {item.title}
                  </h4>
                </div>
              </div>
              <p className="text-muted mb-6 text-sm md:text-base font-medium" data-id="element-205">
                {item.desc}
              </p>
              <div className="bg-surface rounded-xl p-5 border border-border/50" data-id="element-206">
                <ul className={`grid grid-cols-1 ${item.featured ? 'md:grid-cols-2' : ''} gap-y-3 gap-x-6`} data-id="element-207">
                  {item.bullets.map((bullet, i) => <li key={i} className="flex items-start text-sm text-ink font-medium" data-id="element-208">
                      <CheckCircle2 className="w-5 h-5 text-success mr-3 shrink-0" data-id="element-209" />
                      {bullet}
                    </li>)}
                </ul>
              </div>
            </motion.div>)}
        </div>

        <div className="bg-primary-dark rounded-2xl p-8 md:p-12 border border-gold/30 shadow-lg" data-id="element-210">
          <h4 className="text-2xl md:text-3xl font-bold text-cream mb-8 text-center font-serif" data-id="element-211">
            Cada protocolo incluye:
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl mx-auto" data-id="element-212">
            {features.map((feature, i) => <div key={i} className="flex items-center text-cream bg-black/20 p-4 rounded-lg border border-white/10" data-id="element-213">
                <span className="text-gold mr-4 text-xl" data-id="element-214">✅</span>
                <span className="text-sm md:text-base font-medium" data-id="element-215">
                  {feature}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}